interface PizzaMenu {
	starter: string;
	pizza: string;
	beverage: string;
	dessert: string;
}

export const simpleMenu: PizzaMenu = {
	starter: 'Salad',
	pizza: 'perce',
	beverage: 'coke',
	dessert: 'Vanilla',
};

export function adjustMenu(
	menu: PizzaMenu,
	menuEntry: keyof PizzaMenu,
	change: string,
) {
	menu[menuEntry] = change;
	return menu;
}
